import axiosInstance from './axiosInstance';
import * as actions from './apiActions';
import { showMessage } from '../globals/messageSlice';
import apiSettings from './apiSettings';
import { toast } from 'react-toastify';

const api =
	({ dispatch }) =>
	next =>
	async action => {
		if (typeof action === 'function') {
			return next(action);
		} else {
			if (action.type !== actions.apiCallBegan.type) return next(action);
		}

		const { api, url, method, params, data, onStart, onSuccess, onError, toastNotification } = action.payload;

		if (onStart) dispatch({ type: onStart });

		next(action);

		if (!api) {
			dispatch(
				showMessage({
					message: 'No se ha especificado el API correspondiente ',
				})
			);
		}
		try {
			const fullUrl = `${apiSettings[api].url}${url}`;
			const response = await axiosInstance.request({
				headers: {
					[apiSettings[api].keyName]: apiSettings[api].key,
				},
				url: fullUrl,
				method,
				params,
				data,
			});
			dispatch(actions.apiCallSuccess(response.data));

			if (onSuccess) {
				typeof onSuccess === 'function'
					? dispatch(onSuccess(response.data))
					: dispatch({ type: onSuccess, payload: response.data });

				if (toastNotification && toastNotification !== '') toast.success(toastNotification);
			}
		} catch (error) {
			console.log(error);
			dispatch(actions.apiCallFailed(error.message));
			toast.error(`We got on error from our server, please try again`);
			if (onError)
				typeof onError === 'function' ? dispatch(onError(error)) : dispatch({ type: onError, payload: error });
		}
	};

export default api;
